/**
 * Risk domain contracts.
 * Mirrors server/app/domain/risk/contracts.py
 */

import { VehicleClass } from './mitigation';

export enum RiskTier {
  MINIMAL = 'minimal',
  LOW = 'low',
  MODERATE = 'moderate',
  HIGH = 'high',
  SEVERE = 'severe',
}

export interface RiskAssessment {
  friction_estimate: number;
  risk_tier: RiskTier;
  vulnerable_vehicle_classes: VehicleClass[];
}

export interface RiskThresholds {
  minimal_min: number;
  low_min: number;
  moderate_min: number;
  high_min: number;
  severe_min: number;
}

export const RISK_TIER_COLORS: Record<RiskTier, string> = {
  [RiskTier.MINIMAL]: 'var(--color-risk-minimal)',
  [RiskTier.LOW]: 'var(--color-risk-low)',
  [RiskTier.MODERATE]: 'var(--color-risk-moderate)',
  [RiskTier.HIGH]: 'var(--color-risk-high)',
  [RiskTier.SEVERE]: 'var(--color-risk-severe)',
};

export const RISK_TIER_LABELS: Record<RiskTier, string> = {
  [RiskTier.MINIMAL]: 'Minimal',
  [RiskTier.LOW]: 'Low',
  [RiskTier.MODERATE]: 'Moderate',
  [RiskTier.HIGH]: 'High',
  [RiskTier.SEVERE]: 'Severe',
};
